import { Link, useLocation } from "react-router";
import { useEffect, useState } from "react";

import { NETWORK_NAME } from "@/lib/config";
import { STAKING_ENABLED } from "@/lib/features";
import { ConnectButton, WalletNetworkNotice } from "./ConnectButton";
import { CspImage } from "./CspImage";

const NAV = [
  { href: "/claim", label: "Migrasi" },
  { href: "/verify", label: "Verifikasi" },
  { href: "/contract-addresses", label: "Kontrak" },
  { href: "/security", label: "Keamanan" },
  ...(STAKING_ENABLED ? [{ href: "/staking", label: "Staking" }] : []),
  { href: "/daftar-vendor", label: "Vendor" },
];

export function SiteHeader() {
  const { pathname } = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems = NAV.map((item) => {
    const active = item.href === "/" ? pathname === "/" : pathname.startsWith(item.href);

    return (
      <Link
        key={item.href}
        to={item.href}
        aria-current={active ? "page" : undefined}
        onClick={() => setMobileOpen(false)}
        className={`site-nav__link ${active ? "site-nav__link--active" : ""}`}
      >
        {item.label}
      </Link>
    );
  });

  return (
    <header className={`site-header ${scrolled ? "site-header--scrolled" : ""}`}>
      <div className="site-header__inner">
        <Link
          to="/"
          onClick={() => setMobileOpen(false)}
          className="site-brand"
          aria-label="AsetQu, kembali ke beranda"
        >
          <span className="brand-mark">
            <CspImage src="/asetqu.png" alt="" width={64} height={64} loading="eager" />
          </span>
          <span className="site-brand__copy">
            <strong>AsetQu</strong>
            <span>Migration Terminal</span>
          </span>
        </Link>

        <span className="network-badge">
          <span aria-hidden />
          {NETWORK_NAME}
        </span>

        <nav className="site-nav" aria-label="Navigasi utama">
          {navItems}
        </nav>

        <div className="site-header__wallet">
          <ConnectButton />
        </div>

        <button
          type="button"
          className="mobile-menu-button"
          aria-expanded={mobileOpen}
          aria-controls="mobile-navigation"
          aria-label={mobileOpen ? "Tutup menu" : "Buka menu"}
          onClick={() => setMobileOpen((open) => !open)}
        >
          <span className="relative block h-4 w-5" aria-hidden>
            <span
              className={`absolute left-0 top-0.5 h-0.5 w-5 bg-current transition-transform ${
                mobileOpen ? "translate-y-[5px] rotate-45" : ""
              }`}
            />
            <span
              className={`absolute left-0 top-[7px] h-0.5 w-5 bg-current transition-opacity ${
                mobileOpen ? "opacity-0" : ""
              }`}
            />
            <span
              className={`absolute bottom-0.5 left-0 h-0.5 w-5 bg-current transition-transform ${
                mobileOpen ? "-translate-y-[5px] -rotate-45" : ""
              }`}
            />
          </span>
        </button>

        <div
          id="mobile-navigation"
          className={`mobile-navigation ${mobileOpen ? "mobile-navigation--open" : ""}`}
        >
          <nav className="mobile-navigation__links" aria-label="Navigasi seluler">
            {navItems}
          </nav>
        </div>
      </div>
      <WalletNetworkNotice />
    </header>
  );
}
